@use '../common/colors.scss' as colors;
@use '../common/vars.scss' as vars;

#start {
  max-width: 700px;
  margin: 0 auto;

  @media screen and (max-width: vars.$mobile) {
    padding: 0 6px;
  }
}

// Header styles
.start-header-wrapper {
  margin-bottom: 1em;

  h2 {
    font-size: 32px;
    text-align: center;
    font-weight: 500;
    line-height: 1.1;
    margin: 1em 0 0.625em 0;
  }

  @media screen and (max-width: vars.$mobile) {
    h2 {
      font-size: 20px;
      text-align: left;
      margin: 1.05em 0 1em 0;
    }
  }
}

.start-subheader {
  text-align: center;
  font-size: 0.9em;
  font-weight: 400;
  width: 70%;
  margin: 0 auto;
  letter-spacing: -0.1px;
  color: colors.$body-text;

  @media screen and (max-width: vars.$mobile) {
    width: 100%;
    text-align: left;
  }
}

.start-subheader-no-inquiry {
  font-weight: 500;
}

.start-subheader-learn-more {
  font-weight: 500;
  text-decoration: underline;

  &:hover {
    color: colors.$link;
  }
}

.start-body {
  width: 66.6666%;
  margin: 0 auto;

  @media screen and (max-width: vars.$mobile) {
    width: 100%;
  }
}

// StartInfo styles
.start-info-pricing {
  margin-top: 2em;
  margin-bottom: 2em;
  font-size: 0.9em;
  letter-spacing: 0.24px;
  background-color: #eff4fa;
  padding: 1.4em;

  .subvention-promo {
    width: 100%;
    margin: 1em 0 0;
    background-color: #e3f1f7;
    color: #3a3b41;
    border-radius: 4px;

    > .promo-label {
      font-size: 14px;
      font-weight: 500;
      padding: 16px;
    }
  }
}

.start-onboard-spend-readonly {
  margin-top: 2em;
  margin-bottom: 2em;
}

.start-info-pricing-estimated-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  color: colors.$body-text;

  &:first-child {
    font-size: 1em;
    font-weight: 500;
    color: colors.$header;
  }

  @media screen and (max-width: vars.$mobile) {
    flex-direction: column;
    align-items: center;
  }
}

.start-info-pricing-estimated-from,
#start-info-estimated-currency {
  color: colors.$teal;
  font-weight: 500;
}

.start-info-pricing-estimated-from {
  font-size: 1em;
  font-weight: 500;
}

#start-info-estimated-currency {
  font-size: 1.25em;
}

.start-info-legal-notice {
  display: block;
  font-size: 0.85em;
  letter-spacing: -0.28px;
  line-height: 17px;
  margin-top: 0.4em;

  @media screen and (max-width: vars.$mobile) {
    text-align: center;
    margin-top: 1em;
  }
}

// Input styles
.start-required-fields {
  font-size: 0.75em;
  text-align: right;
}

.start-inputs {
  display: flex;
  flex-wrap: wrap;

  & > * {
    width: 100%;
    padding: 0 6px;
  }
}

.start-input-half {
  width: 50%;
}

.start-input-half-desktop {
  width: 50%;

  @media screen and (max-width: vars.$mobile) {
    width: 100%;
  }
}

:global(.address-input-wrapper) {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 0;

  > div {
    width: 50%;
    padding: 0 6px;

    > div {
      height: 34px;
      border-radius: 3px;
      padding: 6px 12px;
    }

    @media screen and (max-width: vars.$mobile) {
      width: 100%;
    }
  }
}

#start-marketing-communication-opt-in {
  margin: 0.5em auto;

  label {
    margin: 0;

    & > span:first-of-type {
      margin: 9px 9px 9px 0;
      padding: 0;
    }
  }

  span {
    font-size: 0.75em;
  }
}

.start-footnotes {
  margin-bottom: 1em;
  font-size: 0.75em;
  text-align: center;

  a {
    display: inline;

    &:hover {
      text-decoration: underline;
    }
  }

  @media screen and (max-width: vars.$mobile) {
    text-align: left;
  }
}

.start-form-submit {
  margin-bottom: 10px;
  font-size: 1.125em;
  padding: 10px 16px;
}

.start-form-submit:global(.disabled) {
  opacity: 0.1;
  cursor: not-allowed;
}

// Flexpay
.cobrand-faqs,
:global(.flexpay) .cobrand-faqs {
  font-weight: 500;
  font-size: 11px;
  padding: 4px 8px;
  color: colors.$flexpay-title;
  background-color: colors.$white;
  border: 2px solid colors.$flexpay-border;
  border-radius: 4px;
  text-decoration: none;
  line-height: 16px;

  &:hover {
    color: colors.$flexpay-title;
  }
}

:global(.flexpay) {
  .start-header-wrapper {
    margin: 0 auto;
  }

  .start-subheader {
    color: colors.$flexpay-body-text;
    font-size: 1em;
    letter-spacing: 0;
    font-weight: 400;
  }

  .start-header,
  .start-subheader,
  .start-body {
    width: 100%;
  }

  .start-header-wrapper h2,
  .start-subheader {
    text-align: left;
  }

  .start-body {
    margin-top: 8px;
  }

  .start-info-pricing {
    background-color: colors.$flexpay-banner-background;
    border-radius: 8px;
    padding: 19px 15px;
    font-size: 1em;
    margin: 1.5em 0;

    .subvention-promo {
      width: 100%;
      margin: 1em 0 0;
      background-color: #e3f1f7;
      color: #3a3b41;
      border-radius: 4px;

      > .promo-label {
        font-size: 14px;
        font-weight: 500;
        padding: 16px;
      }
    }
  }

  .start-info-pricing-estimated-wrapper {
    color: colors.$flexpay-title;
    justify-content: flex-start;
  }

  .start-info-pricing-estimated-from {
    margin-left: 5px;
  }

  .start-info-legal-notice {
    line-height: 24px;
  }

  #start {
    max-width: 452px;
    padding: 0 10px;
  }

  #start-info-estimated-currency {
    font-size: 1em;
  }

  .start-info-pricing-estimated-from,
  #start-info-estimated-currency {
    color: colors.$flexpay-green;
  }

  .start-footnotes {
    line-height: 16px;
    text-align: left;
    font-size: 13px;
    margin-bottom: 24px;
  }

  .start-form-submit {
    margin-bottom: 24px;
    padding: 18px 0;
    font-size: 1em;
  }

  .start-inputs {
    i {
      color: colors.$flexpay-title !important;
    }
  }

  #start-marketing-communication-opt-in {
    margin: 20px 0;

    span {
      font-size: 14px;
      color: colors.$flexpay-body-text;
    }

    :global(.MuiCheckbox-root) span {
      color: colors.$flexpay-link;
    }
  }

  @media screen and (max-width: vars.$mobile) {
    .start-header-wrapper {
      width: 100%;
    }

    .start-info-pricing-estimated-wrapper {
      flex-direction: column;
      align-items: flex-start;
    }

    .start-info-legal-notice {
      text-align: left;
      margin-top: 5px;
    }
  }
}
